import { matchIsValidTel, MuiTelInputInfo } from "mui-tel-input";
import forbiddenPhones from "./forbiddenPhones";
import { messages } from "./messages";

export const validatePhone = (
  phone: MuiTelInputInfo | string | null,
  message?: string,
) => {
  if (!phone) {
    return true;
  }
  if (typeof phone === "string") {
    if (matchIsValidTel(phone)) {
      return true;
    } else return message || messages.defaultMessage;
  }
  const { nationalNumber, countryCode, numberValue } = phone;

  const isValid = matchIsValidTel(numberValue || "", {
    onlyCountries: countryCode ? [countryCode] : undefined,
  });

  let val = String(phone.numberValue ?? "").trim();
  if (!val.startsWith("+")) val = "+" + val;

  if (forbiddenPhones.has(val.slice(1))) {
    return messages.forbiddenErrorMsg;
  }

  if (nationalNumber && !isValid) {
    return message || messages.defaultMessage;
  } else {
    return true;
  }
};
